/**
 * Dark mode toggle.
 *
 * - Default is always dark. Light mode applies only when the visitor opts in.
 * - Clicking [data-theme-toggle] toggles light/dark and persists the choice in
 *   localStorage ('ligo-theme' = 'light' | 'dark').
 *
 * The initial <html class="dark"> is set pre-paint by an inline script in
 * header.php (anti-FOUC); this module only wires up the toggle.
 */
const STORAGE_KEY = 'ligo-theme'

function isDark() {
  return document.documentElement.classList.contains('dark')
}

// Keep the brand logo in sync: dark header (always in dark mode) uses the
// light logo variant; light mode falls back to the page/scroll logic.
function syncLogo(dark) {
  const brand = document.getElementById('brand')
  if (!brand) return
  const lightLogo = brand.getAttribute('data-brand') // for dark backgrounds
  const darkLogo = brand.getAttribute('data-brandtwo') // for light backgrounds
  if (!lightLogo || !darkLogo) return

  if (dark) {
    brand.setAttribute('src', lightLogo)
    return
  }
  const atTop = window.scrollY <= 70
  const isLightPage = document.body.classList.contains('has-light-page')
  brand.setAttribute('src', atTop ? (isLightPage ? darkLogo : lightLogo) : darkLogo)
}

function apply(dark) {
  document.documentElement.classList.toggle('dark', dark)
  document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.setAttribute('aria-pressed', String(dark))
  })
  syncLogo(dark)
}

function init() {
  // Reflect the pre-paint state on the toggle buttons.
  apply(isDark())

  document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = !isDark()
      apply(next)
      try {
        localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light')
      } catch (e) {}
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
